<template>
    <ol :class="slotsClass">
        <li v-for="(slot, index) in slotDates" :key="index" class="slots__slot">
            <common-time :date="slot.from"></common-time>

            <template v-if="slot.to">
                {{ $t('common.microcopy.to') }}

                <common-time :date="slot.to"></common-time>
            </template>
        </li>
    </ol>
</template>

<script>
    import dayjs from 'dayjs'

    export default {
        props: {
            slots: { type: Array, required: true },
            hasUnderline: { type: Boolean, default: false },
        },

        computed: {
            slotDates() {
                return this.slots.map((slot) => ({
                    from: this.momentDate(slot.from),
                    to: slot.to ? this.momentDate(slot.to) : null,
                }))
            },

            slotsClass() {
                return {
                    slots: true,
                    'slots--has-underline': this.hasUnderline,
                }
            },
        },

        methods: {
            momentDate(moment) {
                return dayjs().startOf('day').add(moment, 'minute')
            },
        },
    }
</script>
